<template>
  <div id="app" class="uk-light">
    <nav class="uk-navbar uk-navbar-transparent">
        <div class="uk-navbar-left">
            <div class="uk-navbar-item uk-logo">
              Orthopedic Hardware Radiographs &amp; Complications
            </div>
        </div>
        <div class="uk-navbar-right">
            <ul class="uk-navbar-nav">
                <li><router-link to="lesson">Guided Tour</router-link></li>
                <li><router-link to="quiz">Quiz</router-link></li>
                <li><router-link to="reference">Library</router-link></li>
            </ul>
        </div>
    </nav>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html, body {
  /* doesn't work on prod for some reason: background-color: black; */
  min-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue